import React, {useEffect, useState} from "react";
import {ColorPicker} from "antd";
import Color from "color";

const StyleColourPicker = props => {
    const {defaultValue, onChange, onChangeComplete, ...other} = props;
    const [colour, setColour] = useState(defaultValue || "");

    useEffect(() => {
        setColour(defaultValue || "");
    }, [defaultValue]);

    function parseColour(colour) {
        if (!colour) return null;

        if (typeof colour === 'string') {
            if (colour === 'var(--border-colour)') return Color('#ff0000');
            return Color(colour);
        } else if (colour && typeof colour.toHexString === 'function') {
            return Color(colour.hex());
        }
        return null;
    }

    const handleColourChange = (antdColor) => {
        const hex = antdColor.toHexString();
        if (hex === colour) return;

        const colourObj = Color(hex);
        setColour(hex);
        onChange?.(colourObj, false);
    };

    const handleComplete = (antdColor) => {
        const hex = antdColor.toHexString();
        const colourObj = Color(hex);
        onChangeComplete?.(colourObj, true);
    }

    return (
        <>
            <ColorPicker
                {...other}
                format={'hex'}
                value={colour}
                onChange={handleColourChange}
                onChangeComplete={handleComplete}
            />
        </>
    )
}

export default StyleColourPicker;